import { render } from "./UpdateUsersPassword.vue?vue&type=template&id=44df90f2"
import script from "./UpdateUsersPassword.vue?vue&type=script&lang=js"
export * from "./UpdateUsersPassword.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__